module.exports = __webpack_public_path__ + "static/media/pheasant_specification.505dbee4.md";